function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3866",
  "data-name": "Rectangle 3866",
  width: 30,
  height: 30,
  rx: 15,
  fill: "#2fcc71"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "cart",
  d: "M3559.435,5314.31a1.631,1.631,0,1,1,1.631,1.589A1.615,1.615,0,0,1,3559.435,5314.31Zm-6.522,0a1.631,1.631,0,1,1,1.632,1.589A1.613,1.613,0,0,1,3552.913,5314.31Zm1.932-2.224a2.279,2.279,0,0,1-2.238-1.792l-1.59-7.755h-1.689a.319.319,0,1,1,0-.639h1.956a.321.321,0,0,1,.318.255l.339,1.654h11.732a.323.323,0,0,1,.328.319.176.176,0,0,1,0,.042l-.51,3.975a1.62,1.62,0,0,1-1.618,1.394h-8.753l.128.629a1.625,1.625,0,0,0,1.6,1.279h7.527a.319.319,0,1,1,0,.639Z",
  transform: "translate(-3542 -5293.899)",
  fill: "#fff"
});

function SvgStep1Active(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Active);
export default __webpack_public_path__ + "static/media/step1active.179353b0.svg";
export { ForwardRef as ReactComponent };